<template>
  <v-card>
    <v-layout justify-center>
      <!--タイトル-->
      <v-card-title class="head">
        {{ title }}
        <!--タイトル横アイコン-->
        <v-icon
        color="black"
        class="ml-2">
          {{ icon }}
        </v-icon>
      </v-card-title>
    </v-layout>
    <Summary></Summary>
    <!--ホームページ作成方法について-->
    <Method></Method>
    <!--料金-->
    <Price></Price>
    <!--実績-->
    <Performance></Performance>
    <!--お問い合わせ-->
    <contact></contact>
  </v-card>
</template>

<script>
import Summary from './Summary'
import Method from './Method'
import Price from './Price'
import Performance from './Performance'
import contact from '../contact'

export default {
  data () {
    return {
      // タイトル
      title: '学術機関向けサイト作成',
      // タイトル横のアイコン
      icon: 'mdi-file-document-outline'
    }
  },
  components: {
    Summary,
    Method,
    Price,
    Performance,
    contact
  }
}
</script>
